// extracted by mini-css-extract-plugin
module.exports = {"pwdPop":"pwdPop","popMain":"popMain","close":"close","pwdWrap":"pwdWrap","pwd":"pwd","btn":"btn"};